import * as Scrivito from "scrivito"
import { ErrorPage } from "shared/ui/error-page/ErrorPage"

import { ProductPageConnector } from "pages/product-page/ProductPageConnector"

import { ProductObjClass } from "./ProductObjClass"

Scrivito.provideComponent(ProductObjClass, ({ page }) => {
  const productType = page.get("productType")

  if (!productType || typeof productType !== "string") {
    return <ErrorPage />
  }

  return <ProductPageConnector productType={productType} key={productType} />
})
